import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Constat from "@/components/Constat";
import HowItWorks from "@/components/HowItWorks";
import Integrations from "@/components/Integrations";
import UseCases from "@/components/UseCases";
import UseCasesGrid from "@/components/UseCasesGrid";
import Security from "@/components/Security";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import WaitlistCTA from "@/components/WaitlistCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const { hash } = window.location;
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView();
  }, []);

  return (
    <main
      data-testid="landing-root"
      className="min-h-screen bg-[#FAFAF7] text-[#1A1814] selection:bg-[#437DEA] selection:text-white"
    >
      <Header />
      <Hero />
      <Constat />
      <HowItWorks />
      <Integrations />
      <UseCases />
      <UseCasesGrid />
      <Security />
      <Testimonials />
      <FAQ />
      <WaitlistCTA />
      <Footer />
    </main>
  );
}
